export default "__VITE_ASSET__6rzLusKg__"